"use strict";

export default /*@ngInject*/ $timeout => {
  return {
    restrict: "A",
    link: function(scope, element, attrs) {
      scope.$watch(attrs.autoFocus, function(value) {
        if (value === true) {
          $timeout(function() {
            element[0].focus();
            scope[attrs.autoFocus] = false;
          });
        }
      });
    }
  };
};
